var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSloganPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 161,
    viewBox: "0 0 350 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.124 7.58829C145.521 -0.00707313 155.537 -1.98072 163.354 2.00925C191.506 16.3788 224.96 16.3788 253.111 2.00925C260.928 -1.98071 270.944 -0.00707547 275.341 7.58828L348.069 133.221C352.911 141.586 344 151.166 335.307 146.941L323.198 141.056C301.18 130.354 275.467 130.354 253.448 141.056C224.901 154.931 191.564 154.931 163.017 141.056C140.998 130.354 115.285 130.354 93.2663 141.056L81.1583 146.941C72.4654 151.166 63.5538 141.585 68.3961 133.221L141.124 7.58829Z",
    fill: "url(#paint0_linear_3443_12317)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M162.463 3.75407C155.386 0.141733 146.595 2.04799 142.82 8.56974L70.0915 134.202C66.2174 140.894 73.3471 148.559 80.3019 145.179L92.4099 139.294C114.969 128.329 141.314 128.329 163.873 139.294C191.879 152.906 224.585 152.906 252.592 139.294C275.151 128.329 301.496 128.329 324.055 139.294L336.163 145.179C343.118 148.559 350.248 140.894 346.374 134.202L273.645 8.56974C269.87 2.04799 261.079 0.141737 254.002 3.75407C225.291 18.4092 191.174 18.4092 162.463 3.75407Z",
    stroke: "url(#paint1_linear_3443_12317)",
    strokeOpacity: 0.2,
    strokeWidth: 3.91795
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.542 72.6538C224.394 35.732 230.491 22.8343 254.068 3.44712C260.847 -2.12699 270.944 -0.00259981 275.341 7.59276L348.069 133.225C352.911 141.59 344 151.171 335.307 146.946L323.198 141.06C301.18 130.358 275.467 130.358 253.448 141.06C224.901 154.935 191.564 154.935 163.017 141.06C140.998 130.358 115.285 130.358 93.2663 141.06L81.1583 146.945C72.4654 151.17 63.5538 141.59 68.3961 133.225L106.247 67.8406C106.247 67.8406 183.624 115.581 205.542 72.6538Z",
    fill: "url(#paint2_linear_3443_12317)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M255.313 4.96023C232.857 23.4251 226.562 35.7644 209.118 69.9568C208.521 71.1268 207.911 72.3223 207.287 73.5446C201.472 84.9327 191.921 90.3103 181.073 91.9486C170.325 93.5718 158.276 91.5422 147.117 88.2225C135.927 84.8939 125.458 80.2153 117.802 76.3808C113.97 74.4614 110.832 72.7482 108.65 71.513C107.995 71.1424 107.426 70.8148 106.949 70.5373L70.0915 134.206C66.2174 140.899 73.3471 148.564 80.302 145.183L92.41 139.298C114.969 128.334 141.314 128.334 163.873 139.298C191.879 152.911 224.585 152.911 252.592 139.298C275.151 128.334 301.496 128.334 324.055 139.298L336.163 145.184C343.118 148.564 350.248 140.899 346.374 134.207L273.645 8.57421C269.817 1.9607 261.101 0.200787 255.313 4.96023Z",
    stroke: "url(#paint3_linear_3443_12317)",
    strokeOpacity: 0.1,
    strokeWidth: 3.91795
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8404 112.784L98.6672 118.397C104.075 122.842 112.062 122.063 116.508 116.656L122.121 109.829C112.764 102.958 99.6922 104.233 91.8404 112.784Z",
    fill: "url(#paint4_linear_3443_12317)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.079 111.439L118.466 118.266C114.02 123.673 114.8 131.661 120.207 136.106L127.034 141.719C133.905 132.362 132.63 119.291 124.079 111.439Z",
    fill: "url(#paint5_linear_3443_12317)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.424 143.677L118.499 137.984C113.146 133.583 105.238 134.354 100.837 139.708L95.1436 146.632C104.5 153.504 117.572 152.228 125.424 143.677Z",
    fill: "url(#paint6_linear_3443_12317)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1854 145.022L98.7983 138.196C103.244 132.788 102.465 124.801 97.0573 120.355L90.2304 114.742C83.3591 124.099 84.6348 137.171 93.1854 145.022Z",
    fill: "url(#paint7_linear_3443_12317)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1784 117.775L93.0209 112.712C100.448 105.223 112.214 104.075 120.949 109.987L115.886 116.144C111.723 121.208 104.242 121.938 99.1784 117.775ZM119.088 118.777L124.15 112.619C131.64 120.046 132.788 131.813 126.876 140.547L120.718 135.485C115.654 131.321 114.924 123.841 119.088 118.777ZM117.988 138.606L124.243 143.749C116.817 151.238 105.05 152.386 96.3156 146.474L101.459 140.219C105.578 135.209 112.978 134.487 117.988 138.606ZM98.1765 137.684L93.114 143.842C85.6248 136.415 84.4765 124.649 90.3886 115.914L96.5461 120.977C101.61 125.14 102.34 132.62 98.1765 137.684Z",
    stroke: "url(#paint8_linear_3443_12317)",
    strokeOpacity: 0.5,
    strokeWidth: 1.60984
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0124 116.173L14.4741 120.491C17.216 123.912 22.2116 124.462 25.6321 121.72L29.9506 118.258C25.1003 112.843 16.9248 111.943 11.0124 116.173Z",
    fill: "url(#paint9_linear_3443_12317)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9435 119.497L26.6251 122.959C23.2045 125.701 22.6544 130.696 25.3963 134.117L28.858 138.435C34.2732 133.585 35.1736 125.41 30.9435 119.497Z",
    fill: "url(#paint10_linear_3443_12317)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6193 139.428L24.108 135.048C21.3935 131.662 16.4478 131.117 13.0615 133.831L8.68106 137.343C13.5313 142.758 21.7068 143.658 27.6193 139.428Z",
    fill: "url(#paint11_linear_3443_12317)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68812 136.104L12.0066 132.642C15.4271 129.901 15.9773 124.905 13.2354 121.484L9.77369 117.166C4.35844 122.016 3.45812 130.192 7.68812 136.104Z",
    fill: "url(#paint12_linear_3443_12317)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8674 120.176L11.7451 116.281C17.2604 112.647 24.6196 113.457 29.2119 118.205L25.3169 121.327C22.1135 123.895 17.4352 123.379 14.8674 120.176ZM26.9403 123.352L30.8354 120.23C34.4696 125.745 33.6592 133.104 28.9119 137.697L25.7896 133.802C23.2218 130.598 23.737 125.92 26.9403 123.352ZM23.7147 135.363L26.8866 139.32C21.3712 142.954 14.0121 142.144 9.41974 137.397L13.3767 134.225C16.5459 131.684 21.1743 132.194 23.7147 135.363ZM11.6913 132.249L7.79627 135.371C4.16208 129.856 4.9725 122.497 9.7198 117.905L12.8421 121.8C15.4099 125.003 14.8947 129.681 11.6913 132.249Z",
    stroke: "url(#paint13_linear_3443_12317)",
    strokeOpacity: 0.5,
    strokeWidth: 1.00814
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6387 134.337L40.3981 131.186C49.7123 128.69 55.2398 119.117 52.744 109.802L49.5931 98.0429C34.3965 103.02 25.3506 118.688 28.6387 134.337Z",
    fill: "url(#paint14_linear_3443_12317)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9661 97.1391L56.117 108.899C58.6128 118.213 68.1867 123.74 77.5009 121.245L89.2603 118.094C84.2832 102.897 68.6153 93.8511 52.9661 97.1391Z",
    fill: "url(#paint15_linear_3443_12317)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1641 121.467L78.2361 124.663C69.015 127.133 63.5427 136.612 66.0135 145.833L69.2096 157.761C84.4063 152.784 93.4521 137.116 90.1641 121.467Z",
    fill: "url(#paint16_linear_3443_12317)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8367 158.665L62.6857 146.905C60.19 137.591 50.6161 132.063 41.3018 134.559L29.5424 137.71C34.5195 152.907 50.1874 161.953 65.8367 158.665Z",
    fill: "url(#paint17_linear_3443_12317)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1111 130.115L29.5047 132.957C27.0652 118.635 35.2078 104.531 48.8311 99.4829L51.6731 110.089C54.0103 118.812 48.8338 127.778 40.1111 130.115ZM57.188 108.612L54.346 98.0052C68.6684 95.5657 82.7718 103.708 87.8204 117.332L77.214 120.174C68.4912 122.511 59.5253 117.334 57.188 108.612ZM78.523 125.734L89.2981 122.847C91.7376 137.169 83.5949 151.272 69.9717 156.321L67.0845 145.546C64.7722 136.916 69.8934 128.046 78.523 125.734ZM61.6147 147.192L64.4567 157.799C50.1344 160.238 36.0309 152.095 30.9824 138.472L41.5888 135.63C50.3116 133.293 59.2775 138.469 61.6147 147.192Z",
    stroke: "url(#paint18_linear_3443_12317)",
    strokeOpacity: 0.5,
    strokeWidth: 2.21753
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3443_12317",
    x1: 194.363,
    y1: -0.00585988,
    x2: 209.055,
    y2: 78.3528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F83600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#940000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3443_12317",
    x1: 253.133,
    y1: 22.0325,
    x2: 111.111,
    y2: 58.7792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564103,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3443_12317",
    x1: 349.437,
    y1: 0.305176,
    x2: 349.437,
    y2: 151.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F83600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3443_12317",
    x1: 348.633,
    y1: 132.224,
    x2: 76.8246,
    y2: 124.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279686,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511557,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.52
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3443_12317",
    x1: 111.635,
    y1: 104.388,
    x2: 98.9625,
    y2: 149.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3443_12317",
    x1: 111.635,
    y1: 104.388,
    x2: 98.9625,
    y2: 149.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3443_12317",
    x1: 111.635,
    y1: 104.388,
    x2: 98.9625,
    y2: 149.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3443_12317",
    x1: 111.635,
    y1: 104.388,
    x2: 98.9625,
    y2: 149.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3443_12317",
    x1: 115.348,
    y1: 155.748,
    x2: 81.8427,
    y2: 127.378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279686,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511557,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.52
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3443_12317",
    x1: 24.2241,
    y1: 113.574,
    x2: 10.6155,
    y2: 139.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3443_12317",
    x1: 24.2241,
    y1: 113.574,
    x2: 10.6155,
    y2: 139.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3443_12317",
    x1: 24.2241,
    y1: 113.574,
    x2: 10.6155,
    y2: 139.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3443_12317",
    x1: 24.2241,
    y1: 113.574,
    x2: 10.6155,
    y2: 139.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3443_12317",
    x1: 19.8909,
    y1: 145.529,
    x2: 3.00706,
    y2: 123.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279686,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511557,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.52
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3443_12317",
    x1: 35.0937,
    y1: 105.432,
    x2: 75.8057,
    y2: 156.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3443_12317",
    x1: 35.0937,
    y1: 105.432,
    x2: 75.8057,
    y2: 156.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3443_12317",
    x1: 35.0937,
    y1: 105.432,
    x2: 75.8057,
    y2: 156.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3443_12317",
    x1: 35.0937,
    y1: 105.432,
    x2: 75.8057,
    y2: 156.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC229"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE8C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3443_12317",
    x1: 95.6133,
    y1: 142.428,
    x2: 36.9782,
    y2: 157.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.48
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.279686,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511557,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.52
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSloganPic);
export default __webpack_public_path__ + "static/media/slogan-pic.11f29a581f8ff0bebe3f38687289d1be.svg";
export { ForwardRef as ReactComponent };